
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class ReportPurTaxLongDialog extends Serenity.EntityDialog<ReportPurTaxLongRow, any> {
        protected getFormKey() { return ReportPurTaxLongForm.formKey; }
        protected getIdProperty() { return ReportPurTaxLongRow.idProperty; }
        protected getLocalTextPrefix() { return ReportPurTaxLongRow.localTextPrefix; }
        protected getNameProperty() { return ReportPurTaxLongRow.nameProperty; }
        protected getService() { return ReportPurTaxLongService.baseUrl; }
        protected getDeletePermission() { return ReportPurTaxLongRow.deletePermission; }
        protected getInsertPermission() { return ReportPurTaxLongRow.insertPermission; }
        protected getUpdatePermission() { return ReportPurTaxLongRow.updatePermission; }

        protected form = new ReportPurTaxLongForm(this.idPrefix);

    }
}